import { memo } from "react";
import { Button, Flex, FormControl, Heading } from "@chakra-ui/react";
import { AuthInput } from "components/auth/AuthInput";

interface Step3BusinessInfoProps {
  businessName: string;
  industry: string;
  onChangeBusinessName: (value: string) => void;
  onChangeIndustry: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}

export const BusinessInfo = memo(function BusinessInfo({
  businessName,
  industry,
  onChangeBusinessName,
  onChangeIndustry,
  onNext,
  onBack,
}: Step3BusinessInfoProps) {
  return (
    <Flex direction="column" alignItems="center" textAlign="center" w="100%">
      <Heading fontSize="24px" fontWeight="600" lineHeight="31px" mb="25px" color="#000000">
        Tell us about your business
      </Heading>
      <FormControl mb="16px" isRequired>
        <AuthInput
          role="customer"
          chakraVariant="authCustomerNew"
          type="text"
          id="business_name"
          placeholder="Business name"
          value={businessName}
          onChange={(e) => onChangeBusinessName(e.target.value)}
        />
      </FormControl>

      <FormControl mb="25px">
        <AuthInput
          role="customer"
          chakraVariant="authCustomerNew"
          type="text"
          id="industry"
          placeholder="Industry"
          value={industry}
          onChange={(e) => onChangeIndustry(e.target.value)}
        />
      </FormControl>

      <Button
        w="100%"
        h="48px"
        fontSize="16px"
        bgColor="#3A7BFF"
        fontWeight="600"
        color="#FFFFFF"
        borderRadius="25px"
        border="1px solid #3A7BFF"
        mb="12px"
        _hover={{
          bgColor: "#FFFFFF",
          color: "#3A7BFF",
        }}
        _active={{
          bgColor: "#FFFFFF",
          color: "#3A7BFF",
        }}
        _loading={{ pointerEvents: "none" }}
        onClick={onNext}
        isDisabled={!businessName.trim()}
      >
        Next
      </Button>

      <Button
        w="100%"
        h="48px"
        bgColor="white"
        color="#3A7BFF"
        borderRadius="24px"
        fontSize="14px"
        fontWeight="600"
        border="1px solid #3A7BFF"
        _hover={{
          bgColor: "#3A7BFF",
          color: "#FFF",
        }}
        _active={{
          bgColor: "#FFFFFF",
          color: "#3A7BFF",
        }}
        onClick={onBack}
      >
        Back
      </Button>
    </Flex>
  );
});
